<template lang="html">
 <section class="service-issue"  v-if="showFormButton">

    <div class="user-note">
      <p>You may optionally submit a maintenance request form prior to completing your inspection report.</p>
      <button v-on:click="toggleForm" >{{ buttonText }}</button>
    </div>
  <div class="service-issue__form" v-if="showForm">
    <h3>Submit a Service Issue</h3>
    <p>Please list <b>all</b> items you wish to have addressed.</p>
    <div class="form-item">
				<input type="text" v-model="natureOfComplaint" class="standard-case" placeholder="Nature of Complaints" />
    </div>
    <div class="form-item">
				<textarea v-model="additionalInformation" placeholder="Additional Information"></textarea>
    </div>
    <div class="button-area">
      <button v-on:click="submitServiceIssue" v-disabled="!formReady">Submit Maintenance Request</button>
    </div>
  </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'service-issue',
    props: [],
    mounted() {

    },
    data() {
      return {
        showForm : false,
        showFormButton : true, //set to false after form submitted
        buttonText : "Maintenance Request Form",
        natureOfComplaint : '',
        additionalInformation : ''
      }
    },
    methods: {
      toggleForm : function(){
        this.showForm = this.showForm ? false : true;
        this.buttonText = this.showForm ? "Hide Maintenance Form" : "Maintenance Request Form";
      },
      submitServiceIssue : function(){
        this.showForm = false;
        this.showFormButton = false;
        let data = {
          natureOfComplaint : this.natureOfComplaint,
          additionalInformation : this.additionalInformation
        };
        this.$store.dispatch('submitServiceIssue', data).then( () => {
          this.$store.dispatch( 'postMessage', { msg : 'Service issue has been submitted!', timeout : 3000, allowClose : true });
        }).catch( reason => {
            this.$store.dispatch( 'postMessage', { msg : "Could not submit service issue. Please try again.", timeout : 15000, allowClose : true });
            console.log( reason );
            this.showForm = true;
            this.showFormButton = true;
        });
      }
    },
    computed: {
      formReady : function(){
        return this.natureOfComplaint.length > 4;
      }
    }
}
</script>

<style scoped lang="scss">
  .components-service-issue {

  }
</style>
